// utils/categoryRouteMap.js
export const categoryRouteMap = {
  "Addition & Subtraction": "/quiz/math",
  "Sorting": "/quiz/sorting",
  "Multiplication": "/quiz/multiplication",
  "Division": "/quiz/division",
  "Logical Questions": "/quiz/logic",
  "Sudoku": "/quiz/sudoku",
  "Puzzles": "/quiz/puzzles",
  "Money": "/quiz/money",
  "Shapes": "/quiz/shapes",
  "Measurement": "/quiz/measure",
  "Time": "/quiz/time",
  "Fraction": "/quiz/fraction",
};
